import checkIcon from "../icons/check-icon.svg";
import uncheckIcon from "../icons/uncheck-icon.svg";
import questionIcon from "../icons/question-icon.svg";
import arrowRightIcon from "../icons/arrow-right-content.svg";
import refreshIcon from "../icons/refresh.svg";
import moment from "moment";
import {Link, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {fetchWrapper} from "../../helpers";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import penIcon from "../icons/pen-icon.svg";
import {
    Button,
    message,
    notification,
    Popover,
    Space,
    Card,
    Tag,
    Typography,
    Row,
    Col,
    Divider, Avatar,
} from "antd";
import {
    CheckOutlined,
    EditOutlined
} from '@ant-design/icons'
import {EyeOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {useOrganization} from "../../context/organizationContext";
import {useSelector} from "react-redux";

const CHARACTER_LIMITS = {instagram: 2200, linkedin: 3000, facebook: 8000};
const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const PlanCard = ({
                             item,
                             fbPageId,
                             index,
                             isModeration = false,
                             isQuickPublication = false,
                             snTokens = undefined,
                         }) => {
    const user = useSelector((obj) => obj.auth.user);
    const org = useOrganization();
    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const [isMinified, setIsMinified] = useState(true);
    const [postThemeEditText, setPostThemeEditText] = useState(false);
    const [postThemeText, setPostThemeText] = useState(item.description);
    const [post, setPost] = useState();
    const [isHide, setIsHide] = useState(false);
    const [postHasError, setPostHasError] = useState(false);
    const [disapproveLoading, setDisapproveLoading] = useState(false);

    const changePostThemeText = () => {
        if (postThemeEditText) {
            fetchWrapper.put(`${baseUrl}/content-plan/update/${item.id}`, {
                description: postThemeText,
            });
        }
        setPostThemeEditText(!postThemeEditText);
    };

    const openSNErrorNotification = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/profile")}>
                    {t("posts.goToProfile")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("functions.warning"),
            description: t("posts.snErrorMessage"),
            btn,
            key,
        });
    };

    const openNotificationFbPages = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => navigate("/profile?helpFbModal=true")}
                >
                    {t("posts.goToProfile")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("functions.warning"),
            description: t("posts.notSelectedFacebookPage"),
            btn,
            key,
        });
    };

    const checkCharacterLimit = () => {
        if (!post?.post) return true;
        let isValid = true;
        const postLength = post.post.length;

        item.socialNetwork.split(",").forEach((network) => {
            const n = network.trim().toLowerCase();
            const fail = (netName, limit) => {
                const key = `char-limit-${Date.now()}`;
                notificationApi.warning({
                    message: t("functions.warning"),
                    description: (
                        <>
                            {t("functions.characterLimitError", {network: netName, limit})}
                            <div style={{marginTop: 10}}>{t("functions.pleaseEditPost")}</div>
                        </>
                    ),
                    btn: (
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => navigate(`/create-post/${item.id}`)}
                        >
                            {t("functions.editPost")}
                        </Button>
                    ),
                    key,
                    duration: 0,
                });
            };

            if (n.includes("instagram") && postLength > CHARACTER_LIMITS.instagram) {
                fail("Instagram", CHARACTER_LIMITS.instagram);
                isValid = false;
            }
            if (n.includes("linkedin") && postLength > CHARACTER_LIMITS.linkedin) {
                fail("LinkedIn", CHARACTER_LIMITS.linkedin);
                isValid = false;
            }
            if (n.includes("facebook") && postLength > CHARACTER_LIMITS.facebook) {
                fail("Facebook", CHARACTER_LIMITS.facebook);
                isValid = false;
            }
        });

        return isValid;
    };

    const approve = () => {
        const isModeratorFlow = !!isModeration;

        if (!checkCharacterLimit()) return;

        if (!isModeratorFlow) {
            if (
                item.socialNetwork.toLowerCase().includes("instagram") &&
                (!post?.images?.length && !post?.video)
            ) {
                message.warning(t("functions.minMediaForInstagramPostMessage"));
                return;
            }
            if (item.socialNetwork.toLowerCase().includes("facebook") && !fbPageId) {
                openNotificationFbPages();
                return;
            }

            let isCorrected = true;
            item.socialNetwork.split(",").forEach((network) => {
                const n = network?.toLowerCase();
                if (n?.includes("linkedin") && !snTokens?.linkedIn) isCorrected = false;
                if (n?.includes("facebook") && !snTokens?.facebook) isCorrected = false;
                if (n?.includes("instagram") && !snTokens?.instagram) isCorrected = false;
            });
            if (!isCorrected) {
                openSNErrorNotification();
                return;
            }
        }

        let statuses = [];
        if (post?.published_statuses?.length) {
            post?.published_statuses?.forEach((network) => {
                statuses.push(network?.publishedError ? {...network, publishedError: null} : network);
            });
        } else {
            statuses = null;
        }

        fetchWrapper
            .post(`${baseUrl}/post/approve/`, {postId: post.id, socialNetwork: item.socialNetwork})
            .then((res) => {
                if (res && res.post) setPost(res.post);
                else {
                    fetchWrapper
                        .get(`${baseUrl}/post/actual/${item.id}`)
                        .then((actual) => setPost(actual))
                        .catch(() => {
                        });
                }
                setPostHasError(false);
            })
            .catch((error) => {
                try {
                    if (error?.message?.includes("character limit")) {
                        message.error(t("functions.pleaseEditPost"));
                    } else {
                        message.error(t("functions.error"));
                    }
                } catch {
                    message.error(t("functions.error"));
                }
            });
    };

    const disapprove = async () => {
        if (disapproveLoading) return;
        setDisapproveLoading(true);
        try {
            const fresh = await fetchWrapper.get(`${baseUrl}/post/actual/${item.id}`);
            if (fresh) setPost(fresh);

            if (fresh?.published) {
                message.warning(t("plancard.cantCancelPublished"));
                return;
            }

            const res = await fetchWrapper.post(`${baseUrl}/post/disapprove/`, {
                postId: (fresh?.id ?? post?.id),
            });

            if (res && res.post) {
                setPost(res.post);
            } else if (fresh) {
                setPost(fresh);
            }
            setPostHasError(false);
        } catch (e) {
            message.error(t("functions.error"));
        } finally {
            setDisapproveLoading(false);
        }
    };

    const hide = () => {
        if (window.confirm(t("plancard.hiddeConfrim"))) {
            fetchWrapper
                .post(`${baseUrl}/post/hide/${item?.uniqueIndexId}`, {postId: item?.uniqueIndexId})
                .then(() => {
                    setPost();
                    setIsHide(true);
                    message.success(t("plancard.successfullyHidden"));
                })
                .catch(() => message.error(t("functions.error")));
        }
    };

    useEffect(() => {
        fetchWrapper
            .get(`${baseUrl}/post/actual/${item.id}`)
            .then((res) => setPost(res))
            .catch(() => {
            });
    }, [item, index]);

    useEffect(() => {
        let isErr = false;
        post?.published_statuses?.forEach((network) => {
            if (network?.publishedError) isErr = true;
        });
        setPostHasError(isErr);
    }, [post]);

    if (isHide) return null;

    const handleCardClick = (e) => {
        // Не реагируем если клик по интерактивному элементу внутри
        if (e.target.closest('button, a, textarea, input, [role="button"]')) return;
        navigate(`/create-post/${item.id}`);
    };

    const isOwner =
        (item?.User?.id ?? item?.UserId) === user?.id;

    const disapproveLabel =
        isModeration && !isOwner
            ? t("plancard.disapprove")
            : t("plancard.cancel")

    return (
        <>
            {notificationContextHolder}
            <Card
                onClick={handleCardClick}
                hoverable
                bodyStyle={{padding: 8, fontSize: 14, lineHeight: '20px'}}
                className="cursor-pointer post-item p-2 rounded-lg border-l-4 border-t-0 border-r-0 border-b-0 shadow-sm transition-transform hover:scale-[1.02]"
                style={{
                    borderLeft: `3px solid ${
                        post?.published
                            ? "#52c41a"
                            : postHasError || post?.broken
                                ? "#ff4d4f"
                                : post?.approved || post?.approvedExtended
                                    ? "#faad14"
                                    : "#722ed1"
                    }`,
                }}
            >
                {/* TOP: networks + EDIT button + META STATUSES (generated/approved/published/moderated) + network statuses popover dot */}
                <Row align="middle" gutter={[8, 8]}>
                    <Col xs={24} sm={16}>
                        <Space size={8} wrap>
                            {/* Social avatars */}
                            {item?.socialNetwork
                                ?.split(",")
                                .map((n) => n.trim())
                                .filter(Boolean)
                                .map((n, i) => {
                                    const lower = n.toLowerCase();
                                    const label = lower.includes("linkedin")
                                        ? "IN"
                                        : lower.includes("instagram")
                                            ? "IG"
                                            : lower.includes("facebook")
                                                ? "FB"
                                                : n.slice(0, 2).toUpperCase();
                                    const bg =
                                        lower.includes("linkedin")
                                            ? "#0A66C2"
                                            : lower.includes("instagram")
                                                ? "#C13584"
                                                : lower.includes("facebook")
                                                    ? "#1877F2"
                                                    : "#1677ff";
                                    return (
                                        <Avatar key={i} size={22} style={{background: bg, fontSize: 11}}>
                                            {label}
                                        </Avatar>
                                    );
                                })}

                            {/* META STATUSES (moved to top) */}
                            {post ? (
                                <Space size={6} wrap>
                                    {(!item?.User?.name || item?.User?.id === user?.id) ? (
                                        <Tag color={post.post !== "" ? undefined : "gold"}>
                                            {post.post !== "" ? t("plancard.generated") : t("plancard.notGenerated")}
                                        </Tag>
                                    ) : (
                                        <Tag>{item?.User?.name}</Tag>
                                    )}

                                    {org?.organization?.moderatorExist ? (
                                        <Tag
                                            color={
                                                post?.approvedExtended === "moderator_approved"
                                                    ? "green"
                                                    : post?.approvedExtended === "user_approved"
                                                        ? "gold"
                                                        : "red"
                                            }
                                        >
                                            {post?.approvedExtended === "moderator_approved"
                                                ? t("plancard.approved")
                                                : post?.approvedExtended === "user_approved"
                                                    ? t("plancard.onModeration")
                                                    : t("plancard.notApproved")}
                                        </Tag>
                                    ) : (
                                        <Tag color={post?.approved ? "green" : "red"}>
                                            {post?.approved ? t("plancard.approved") : t("plancard.notApproved")}
                                        </Tag>
                                    )}

                                    <Tag color={post?.published ? "green" : post?.broken ? "red" : undefined}>
                                        {post?.published ? t("post.published") : post?.broken ? t("post.broken") : t("post.notpublished")}
                                    </Tag>

                                    {post?.modifiedModerator ? <Tag>{t("posts.postStatusModerated")}</Tag> : null}
                                </Space>
                            ) : (
                                <Tag color="gold">{t("plancard.notGenerated")}</Tag>
                            )}
                        </Space>
                    </Col>

                    {/* Network-specific publish statuses popover as a small dot */}
                    <Col xs={24} sm={8} style={{textAlign: "right"}}>
                        <Popover
                            overlayStyle={{maxWidth: 420}}
                            placement="bottomRight"
                            title={t("posts.postStatusesInfoTitle")}
                            content={
                                Array.isArray(post?.published_statuses) ? (
                                    <Space direction="vertical" size={2} style={{fontSize: 12}}>
                                        {post?.published_statuses?.map((network, i) => (
                                            <Typography.Text
                                                key={i}
                                                type={
                                                    network?.isPublished ? "success" : network?.publishedError ? "danger" : undefined
                                                }
                                            >
                                                <b>{network?.name}: </b>
                                                {network?.isPublished
                                                    ? `${t("post.published")} ${new Date(network?.publishedAt)?.toLocaleDateString()}`
                                                    : network?.publishedError
                                                        ? `${t("post.broken")} "${
                                                            network?.publishedError[i18n.language]
                                                                ? network?.publishedError[i18n.language]
                                                                : network?.publishedError
                                                        }"`
                                                        : t("post.notpublished")}
                                            </Typography.Text>
                                        ))}
                                    </Space>
                                ) : (
                                    <Space size={4} wrap>
                                        {item?.socialNetwork?.split(",").map((n, i) => (
                                            <Tag key={i}>{n}</Tag>
                                        ))}
                                    </Space>
                                )
                            }
                        >
                            <div
                                style={{
                                    display: "inline-block",
                                    width: 10,
                                    height: 10,
                                    borderRadius: 999,
                                    background: post?.published
                                        ? "#52c41a"
                                        : postHasError || post?.broken
                                            ? "#ff4d4f"
                                            : post?.approved || post?.approvedExtended
                                                ? "#faad14"
                                                : "#d9d9d9",
                                    cursor: "pointer",
                                }}
                            />
                        </Popover>
                    </Col>
                </Row>

                {/* TITLE / TOPIC (no purple bg; textarea when editing) */}
                <div style={{marginTop: 6}}>
                    {postThemeEditText ? (
                        <textarea
                            value={postThemeText}
                            onChange={(e) => setPostThemeText(e.target.value)}
                            style={{
                                width: "100%",
                                height: 90,
                                padding: 10,
                                borderRadius: 6,
                                border: "1px solid #f0f0f0",
                                fontSize: 15,
                                lineHeight: '22px'
                            }}
                        />
                    ) : (
                        <Typography.Paragraph
                            style={{marginBottom: 0, fontWeight: 600, fontSize: 15, lineHeight: "22px"}}
                            ellipsis={{rows: 2}}
                        >
                            {postThemeText}
                        </Typography.Paragraph>
                    )}
                </div>

                {/* POST PREVIEW (no purple bg, fixed ellipsis, no expand button) */}
                {post && (
                    <div style={{marginTop: 6}}>
                        <Link to={`/create-post/${item.id}`} onClick={(e) => e.stopPropagation()}>
                            <Typography.Paragraph
                                style={{marginBottom: 0, fontSize: 14, lineHeight: "20px"}}
                                ellipsis={{rows: 2}}
                            >
                                {post.post}
                            </Typography.Paragraph>
                        </Link>
                    </div>
                )}

                {/* ACTIONS (Edit и Hide в одну строку) */}
                <Row align="middle" justify="space-between" style={{marginTop: 10}}>
                    <Col>
                        <Space size={8} wrap>
                            <Button
                                icon={postThemeEditText ? <CheckOutlined/> : <EditOutlined/>}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    changePostThemeText();
                                }}
                                disabled={!!post?.published}
                                size="small"
                            >
                                {postThemeEditText ? t("functions.save") ?? "Save" : t("functions.edit") ?? "Edit"}
                            </Button>
                            {isQuickPublication && (
                                <Button danger size="small" onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    hide();
                                }}>
                                    {t("plancard.hide")}
                                </Button>
                            )}
                        </Space>
                    </Col>
                    <Col>
                        <Space size={8} wrap>
                            {post && ((post?.approvedExtended === "user_approved" || post?.approved) && !post?.published) && (
                                <Button danger size="small" loading={disapproveLoading} onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    disapprove();
                                }}>
                                    {disapproveLabel}
                                </Button>
                            )}
                            {post && (postHasError ? (
                                <Button type="primary" size="small" onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    approve();
                                }}>
                                    {t("plancard.approveAgain")}
                                </Button>
                            ) : (!post?.published &&
                                !(post?.approved || post?.approvedExtended === "moderator_approved") && (
                                    <Button type="primary" size="small" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        approve();
                                    }}>
                                        {item?.User?.id === user?.id || item?.UserId === user?.id
                                            ? new Date(item.date).getTime() < new Date().getTime()
                                                ? t("plancard.publish")
                                                : t("plancard.approve")
                                            : t("plancard.approve")}
                                    </Button>
                                )))}
                        </Space>
                    </Col>
                </Row>

                {/* DATE moved to bottom as plain text */}
                <div style={{marginTop: 6}}>
                    <Typography.Text type="secondary" style={{fontSize: 12}}>
                        {item.weekDay ? `${t(`weekDays.${item.weekDay}`)}, ` : ""}
                        {moment(item.date).format("DD/MM/YYYY")}
                    </Typography.Text>
                </div>
            </Card>
        </>
    );
};
